import type { ComponentProps } from 'react'
import Svg, { Path } from 'react-native-svg'

export function StarAllianceIcon(props: ComponentProps<typeof Svg>) {
  return (
    <Svg width={52} height={29} viewBox="0 0 52 29" fill="none" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.428 5.823A28.067 28.067 0 0126 .051L24.88 4.546l-4.452 1.277z"
        fill="#C9CBCD"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.213 7.764a28.065 28.065 0 01-7.785-1.94l4.453-1.277 3.332 3.217z"
        fill="#5B5C5E"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 .052a28.052 28.052 0 012.212 7.713l-3.333-3.218 1.12-4.495zM18.855 15.062a27.979 27.979 0 01-2.135-3.401 27.964 27.964 0 01-1.632-3.683l3.928 2.455-.161 4.629z"
        fill="#999B9D"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.105 8.258a28.07 28.07 0 01-4.252 6.805l.162-4.63 4.09-2.175z"
        fill="#5B5C5E"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.088 7.978a28.009 28.009 0 018.019.28l-4.091 2.175-3.928-2.455z"
        fill="#C9CBCD"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.158 19.413a28.07 28.07 0 01-7.902 1.393l3.549-2.978 4.353 1.585z"
        fill="#5B5C5E"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.998 13.268a28.091 28.091 0 015.157 6.146l-4.353-1.585-.804-4.561z"
        fill="#999B9D"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.256 20.806A28.083 28.083 0 0122 13.266l.804 4.562-3.548 2.978z"
        fill="#C9CBCD"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.858 12.864a27.974 27.974 0 01-.273 4.006 27.997 27.997 0 01-.844 3.94l-1.735-4.296 2.852-3.65z"
        fill="#999B9D"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.42 15.868a28.105 28.105 0 017.44-3.006l-2.853 3.65-4.587-.644z"
        fill="#C9CBCD"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.739 20.809a27.965 27.965 0 01-3.333-2.24 28.024 28.024 0 01-2.99-2.7l4.588.645 1.735 4.295z"
        fill="#5B5C5E"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7 4.464a28.021 28.021 0 017.21 3.518l-4.62.322-2.59-3.84z"
        fill="#999B9D"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.259 12.468a28.043 28.043 0 01-.56-8.004l2.59 3.84-2.03 4.164z"
        fill="#C9CBCD"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.91 7.982a28.114 28.114 0 01-6.652 4.487l2.031-4.164 4.62-.323z"
        fill="#5B5C5E"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.838 26.681c-.742-.075-1.442-.146-1.442-.846 0-.321.168-.561.503-.715.326-.15.717-.173.92-.173.283 0 .802.045 1.102.345a.768.768 0 01.221.564c0 .036 0 .068-.005.1h.24c0-.018.001-.036.003-.053a.68.68 0 00.003-.06c0-.286-.09-.52-.267-.698-.334-.334-.908-.404-1.33-.404-.426 0-1.045.123-1.391.47a.857.857 0 00-.261.624c0 .913.821.986 1.615 1.058.385.035.748.067 1.026.189.313.136.465.373.465.721a.763.763 0 01-.223.56c-.333.334-.939.37-1.184.37-.6 0-1.039-.134-1.302-.397-.195-.195-.294-.463-.296-.798H0c0 .392.114.707.341.936.308.308.819.465 1.52.465.385 0 1.644-.083 1.644-1.155 0-.935-.847-1.02-1.667-1.103zM6.06 25.047v3.812h-.25v-3.812H4.174v-.228h3.522v.228H6.06zM11.49 28.86l-.595-1.306H8.649l-.6 1.305h-.275l1.858-4.04h.284l1.858 4.04h-.284zm-1.72-3.771l-1.023 2.244H10.8l-1.03-2.244zM16.128 28.86c-.069-.07-.096-.325-.11-.94-.021-.705-.242-.898-1.043-.898h-1.748v1.837h-.254v-4.04h2.009c.773 0 1.367.22 1.367 1.07 0 .421-.255.87-.829 1.002v.014c.491.062.753.4.76.836.007.732.035.973.11 1.119h-.262zm-1.126-3.813h-1.775v1.747h1.713c.25 0 1.147 0 1.147-.918 0-.656-.511-.83-1.085-.83zM22.904 28.86l-.6-1.306h-2.248l-.594 1.305h-.28l1.857-4.04h.29l1.851 4.04h-.276zm-1.72-3.771l-1.028 2.244h2.051l-1.022-2.244zM37.15 28.86l-.6-1.306h-2.248l-.594 1.305h-.28l1.857-4.04h.29l1.851 4.04h-.276zm-1.72-3.771l-1.029 2.244h2.051L35.43 25.09zM27.268 28.631H24.7V24.82h-.255v4.04h2.823v-.228zM31 28.631H28.44V24.82h-.255v4.04H31v-.228zM31.9 28.86v-4.041h.25v4.04h-.25zM41.86 28.86l-3.032-3.675h-.014v3.674h-.248v-4.04h.304l3.032 3.674.013.014v-3.688h.248v4.04h-.303zM48.813 28.86v-4.041h3.152v.228h-2.9v1.609h2.783v.221h-2.783v1.754H52v.228h-3.188zM45.509 28.95c-1.23 0-2.083-.772-2.083-2.105 0-1.056.692-2.116 2.099-2.116.966 0 1.696.456 1.897 1.36h-.256c-.193-.78-.889-1.132-1.641-1.132-1.16 0-1.837.863-1.837 1.885 0 1.009.578 1.88 1.82 1.88.892 0 1.568-.519 1.72-1.396h.263c-.09.767-.774 1.623-1.982 1.623z"
        fill="#000"
      />
    </Svg>
  )
}
